module.exports = __webpack_public_path__ + "img/laptop-mock.6d2ce195.png";